export default "/images/feather.svg?40412753ef861e7cc1dfb5e543328c12";